import PropTypes from 'prop-types';

const displayName = 'Auth';
const propTypes = {};
const defaultProps = {
  userRoles: [
    {
      role: 1,
      site: 'admin',
    },
    {
      role: 2,
      site: 'Head',
    },
    {
      role: 3,
      site: 'SPV',
    },
    {
      role: 4,
      site: 'staff',
    },
  ],
};

export default { displayName, propTypes, defaultProps };
